import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import useWindowIsMobile from '@/utils/hooks/useWindowIsMobile';
import { formatTimeDate } from '@/utils/functions/formatTimeDate';

import styles from '@/views/pages/Template/Template.module.scss';

const TemplateUseFormWrapper = ({children, templateData}) => {
	const { dict } = useSelector((state) => state.app);
	const { categoriesDict } = useSelector((state) => state.data);

	const isMobile = useWindowIsMobile(1199);

	const [ showOnMobile, setShowOnMobile ] = useState(false);

	return (
		<div className={ styles['template-use-container'] }>
			{ (!isMobile || showOnMobile) &&
				<div className={ styles['template-use-infobar'] }>
					{showOnMobile && <div>
						<span className={ styles['template-use-infobar--header'] }>{dict.templates.use.mobileHeader}</span>
					</div>}
					<div>
						<span className={ styles['template-use-infobar--title'] }>{dict.templates.use.dept}: </span>
						<span>{templateData.department.name}</span>
					</div>
					<div>
						<span className={ styles['template-use-infobar--title'] }>{dict.templates.use.category}: </span>
						<span>{categoriesDict[templateData.category.code]}</span>
					</div>
					<div>
						<span className={ styles['template-use-infobar--title'] }>{dict.templates.use.basedOn}: </span>
						<span>
							<Link 
								className={ styles['template-use-infobar--link'] } 
								to={ `/letter/${templateData.letter.id}` }
							>
								{dict.templates.use.see}
							</Link>
						</span>
					</div>
					<div>
						<span className={ styles['template-use-infobar--title'] }>{dict.templates.use.author}: </span><br />
						<span>{templateData.owner.displayName}</span><br />
						{isMobile && <span className={ styles['template-use-infobar--email'] }>{templateData.owner.email}</span>}
					</div>
					<div>
						<span className={ styles['template-use-infobar--title'] }>{dict.templates.use.addedOn}: </span>
						<span>{formatTimeDate(templateData.createdOn)}</span>
					</div>
					<div>
						<span className={ styles['template-use-infobar--title'] }>{dict.templates.use.modifiedOn}: </span>
						<span>{formatTimeDate(templateData.modifiedOn)}</span>
					</div>
				</div>
			}
			{ isMobile && 
				<>
					{ showOnMobile &&
						<div 
							className={ styles['template-use-infobar__show-button'] }
							onClick={ () => { setShowOnMobile(false); } }
						>
							{dict.templates.use.hideMetadata}
							<i className='icon-arrow-up-full' />
						</div> 
					}
					{ !showOnMobile &&
						<div 
							className={ styles['template-use-infobar__show-button'] }
							onClick={ () => { setShowOnMobile(true); } }
						>
							{dict.templates.use.showMetadata}
							<i className='icon-arrow-down-full' />
						</div> 
					}
				</>
			}
			<div className={ styles['template-use-wrapper'] }>
				{children}
			</div>
		</div>
	);
};

export default TemplateUseFormWrapper;